// extracted by mini-css-extract-plugin
module.exports = {"commentsContainer":"Comments_commentsContainer__3Lq9C","textarea":"Comments_textarea__wWmLE"};